import { Auth } from 'aws-amplify';
import Axios from 'axios';

export default class Session {
	/**
	 * This function returns access token of logged in user.
	 * @return {string}
	 */
	static getAccessToken() {
		return localStorage.getItem('ACCESS_TOKEN');
	}

	/**
	 * This function set user access token.
	 * @param token
	 */
	static setAccessToken(token) {
		localStorage.setItem('ACCESS_TOKEN', token);
	}

	/**
	 * This function check for existing session if expired then refresh (if possible by refresh token)
	 */
	static async loadAndRefreshSession() {
		try {
			const currentUser = await Auth.currentSession();
			const accessToken = currentUser.getIdToken().getJwtToken();
			if (accessToken !== this.getAccessToken()) {
				this.setAccessToken(accessToken);
			}
		} catch (err) {
			console.log(err);
		}
	}

	
	

	/**
	 * This function checks for referrals via querystrings and stores it
	 * When creating a user, check this value and store it in User table
	 */
	static trackVisitReferral() {
		try {
			const trackingKey = 'campaign';
			const params = new URL(document.location).searchParams;
			const campaign_data = {
				utm_campaign: params.get('utm_campaign'),
				utm_source: params.get('utm_source')
			};
			const cachedReferralSource = Session.get(trackingKey);
			const hasReferralSource = params.has('utm_source');
			if (!cachedReferralSource && hasReferralSource === true) {
				Session.store(trackingKey, campaign_data);
			}
		} catch (error) {
			console.error('Failed campaign store', error);
		}
	}

	/**
	 * This function store the key value in local
	 * @param key
	 * @param value
	 * @returns void
	 */
	static store(key, value) {
		if (value instanceof Object) {
			localStorage.setItem(key, JSON.stringify(value));
			return;
		}
		localStorage.setItem(key, value);
	}

	/**
	 * This function is used for get value from local
	 * @param {*} key
	 * @returns String
	 */
	static get(key) {
		return JSON.parse(localStorage.getItem(key));
	}

	/**
	 * This function is used to get value without parse
	 * @param {*} key
	 * @returns
	 */
	static getByKey(key) {
		return localStorage.getItem(key);
	}

	/**
	 * This function is used for clear value from local
	 */
	static remove(key) {
		localStorage.removeItem(key);
	}
}
